export default "__VITE_ASSET__B_OmsrUf__"